__turbopack_context__.v({
  "accordion": "udMlXW_accordion",
  "chevron": "udMlXW_chevron",
  "chevronOpen": "udMlXW_chevronOpen",
  "item": "udMlXW_item",
  "link": "udMlXW_link",
  "linkList": "udMlXW_linkList",
  "panelInner": "udMlXW_panelInner",
  "text": "udMlXW_text",
  "title": "udMlXW_title",
  "trigger": "udMlXW_trigger",
});
